import * as React from "react";
import { useEffect } from "react";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { useIntl } from "react-intl";
import { Button } from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import { useSelector, useDispatch } from "react-redux";
import { ROOT_API } from "../../../api/config";
import { ErrorCode } from "../../../api/ErrorCode";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { FormattedMessage } from "react-intl";
import { useForm, Resolver } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";

export default function OutageInformationTable() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onSubmit",
    resolver: yupResolver(),
  });

  const intl = useIntl();

  const columns = [
    {
      field: "id",
      headerName: intl.formatMessage({
        id: "order",
      }),
      width: 70,
    },
    {
      field: "location",
      headerName: intl.formatMessage({
        id: "address",
      }),
      width: 300,
    },
    {
      field: "street",
      headerName: intl.formatMessage({
        id: "street",
      }),
      width: 300,
    },
    {
      field: "outage_date",
      headerName: intl.formatMessage({
        id: "date",
      }),
      width: 150,
    },
    {
      field: "duration",
      headerName: intl.formatMessage({
        id: "duration",
      }),
      width: 150,
    },
    {
      field: "note",
      headerName: intl.formatMessage({
        id: "note",
      }),
      width: 100,
    },
  ];

  const selectedLocale =
    useSelector((state) => state.lang.value) ||
    localStorage.getItem("lang") ||
    "hr";

  const [date, setDate] = React.useState(dayjs());

  const [selectedItems, setSelectedItems] = React.useState([]);

  const [isLoading, setIsLoading] = React.useState(false);

  const [isLoadingCreateNew, setIsLoadingCreateNew] = React.useState(false);

  const [outageDetails, setOutageDetails] = React.useState([]);

  const [role, setRoles] = React.useState("admin");

  const [isOpenCreateNew, setIsOpenCreateNew] = React.useState(false);

  const handleCloseCreateNew = () => {
    reset();
    setIsOpenCreateNew(false);
  };

  const handleOpenCreateNewForm = () => {
    setIsOpenCreateNew(true);
  };

  const handleCrawlDataToday = async () => {
    const axiosObject = axios.create({
      headers: {
        "Content-Type": "application/json",
        lang: selectedLocale,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    });
    try {
      const res = await axiosObject.get(`${ROOT_API}apis/trigger-crawl`);
      if (res) {
        console.log("ndphong res", res);
        Swal.fire({
          icon: "success",
          title: intl.formatMessage({
            id: "crawl_success",
          }),
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error_code
            ? intl.formatMessage({
                id: ErrorCode[error.response.data.error_code],
              })
            : intl.formatMessage({
                id: "there_are_error_occured",
              }),
      });
    }
  };

  const getOutageDetails = async () => {
    const axiosObject = axios.create({
      headers: {
        "Content-Type": "application/json",
        lang: selectedLocale,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    });
    try {
      const res = await axiosObject.post(
        `${ROOT_API}apis/list-outage-detail?page_size=10000&page_num=1`,
        {
          date: date.format("YYYY-MM-DD"),
        }
      );
      if (res) {
        console.log("ndphong res", res);
        setOutageDetails(
          (res.data && res.data.data && res.data.data.result) || []
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error_code
            ? intl.formatMessage({
                id: ErrorCode[error.response.data.error_code],
              })
            : intl.formatMessage({
                id: "there_are_error_occured",
              }),
      });
    }
  };

  const handleSendOutageDetailToUsers = async () => {
    const axiosObject = axios.create({
      headers: {
        "Content-Type": "application/json",
        lang: selectedLocale,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    });
    try {
      const res = await axiosObject.post(
        `${ROOT_API}apis/send-outage-notification`
      );
      if (res) {
        console.log("ndphong res", res);
        Swal.fire({
          icon: "success",
          title: intl.formatMessage({
            id: "sent_notification_success",
          }),
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error_code
            ? intl.formatMessage({
                id: ErrorCode[error.response.data.error_code],
              })
            : intl.formatMessage({
                id: "there_are_error_occured",
              }),
      });
    }
  };

  useEffect(() => {
    getOutageDetails();
  }, [date]);

  return (
    <div style={{ height: 560, width: "100%" }}>
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DatePicker"]}>
            <DatePicker
              label={intl.formatMessage({
                id: "select_date",
              })}
              defaultValue={dayjs()}
              onChange={(newValue) => setDate(newValue)}
            />
          </DemoContainer>
        </LocalizationProvider>
        <div>
          <Button
            variant="contained"
            onClick={() => {
              handleSendOutageDetailToUsers();
            }}
          >
            {intl.formatMessage({
              id: "send_outage_detail_to_users",
            })}
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleCrawlDataToday();
            }}
            style={{
              marginLeft: "20px",
            }}
          >
            {intl.formatMessage({
              id: "crawl_data_today",
            })}
          </Button>
        </div>
      </div>

      <DataGrid
        rows={
          (outageDetails &&
            outageDetails.map((item, index) => {
              return {
                ...item,
                id: index,
              };
            })) ||
          []
        }
        style={{ marginTop: "20px" }}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        pageSizeOptions={[10, 20, 50, 100, 200, 500]}
        checkboxSelection
        onRowSelectionModelChange={(ids) => {
          setSelectedItems(ids);
        }}
      />
    </div>
  );
}
